import { useNavigate, useParams } from 'react-router-dom';
import { Button, Panel } from 'nhsuk-react-components';
import useFetchTeamDetails from 'queries/fetch/fetchTeamDetails';

function TeamRoutingPlansConfirmationPage() {
  const { teamId } = useParams() as { teamId: string };
  const navigate = useNavigate();

  const { data: teamDetails, isLoading: isTeamDetailsLoading } = useFetchTeamDetails({ teamId });

  const handleContinue = () => {
    navigate(`/admin/${teamId}/team-message-plans`);
  };

  if (isTeamDetailsLoading) {
    return (
      null
    );
  }

  return (
    <>
      <Panel>
        <Panel.Title>
          {teamDetails?.team.TEAM_NAME ?? teamId}
          {' '}
          message plans have been added
        </Panel.Title>
        <div>
          The next screen will show your added message plans in a non-editable table.
        </div>
        <div className="nhsuk-u-margin-top-4">
          If you would like to add to the table click the &quot;Add to list&quot; button.
        </div>
      </Panel>
      <Button onClick={handleContinue}>Continue</Button>
    </>
  );
}

export default TeamRoutingPlansConfirmationPage;
